<script lang="ts" setup>
	defineProps<{
		small?: boolean;
	}>();
</script>

<template>
	<i class="w-8 h-8 flex items-center justify-center">
		<svg
			:width="small ? 10 : 20"
			:height="small ? 13 : 26"
			viewBox="0 0 10 13"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_1683_12156)">
				<path
					d="M5 13C4.70383 13.0002 4.41887 12.8849 4.20386 12.6777C3.21703 11.7392 2.33467 10.6933 1.57269 9.55861C0.627384 8.25704 0.0803547 6.70094 0 5.08488C0 3.73629 0.526784 2.44293 1.46447 1.48933C2.40215 0.535727 3.67392 0 5 0C6.32608 0 7.59785 0.535727 8.53553 1.48933C9.47322 2.44293 10 3.73629 10 5.08488C9.91974 6.70117 9.37271 8.25753 8.42731 9.55933C7.66548 10.6941 6.78311 11.7401 5.79614 12.6784C5.58102 12.8853 5.29607 13.0004 5 13ZM5 2.90565C4.5818 2.90551 4.17295 3.0315 3.82516 3.2677C3.47738 3.5039 3.2063 3.83969 3.04619 4.23259C2.88609 4.62549 2.84416 5.05786 2.92572 5.475C3.00727 5.89213 3.20864 6.2753 3.50435 6.57604C3.80007 6.87677 4.17684 7.08156 4.58702 7.1645C4.99719 7.24744 5.42234 7.2048 5.80868 7.04198C6.19503 6.87916 6.52521 6.60347 6.75746 6.24978C6.98972 5.8961 7.11361 5.48031 7.11347 5.055C7.11273 4.48519 6.88983 3.93893 6.49363 3.53601C6.09744 3.13309 5.5603 2.9064 5 2.90565Z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1683_12156">
					<rect
						width="10"
						height="13"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	</i>
</template>